var throttle = require('./throttle');
var debounce = require('./debounce');

module.exports = {
	throttle: throttle,
	debounce: debounce
};



//////////////////
// WEBPACK FOOTER
// ./~/element-ui/~/throttle-debounce/index.js
// module id = 333
// module chunks = 0